function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconNotificationRexOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14 26c0 1.103.896 2 2 2s2-.897 2-2h2a4 4 0 01-8 0h2zm2-24c5.523 0 10 4.477 10 10v8a2 2 0 002 2v2H4v-2a2 2 0 002-2v-8C6 6.477 10.478 2 16 2zm0 2c-4.411 0-8 3.589-8 8v8a3.97 3.97 0 01-.537 2h17.074A3.97 3.97 0 0124 20v-8c0-4.411-3.589-8-8-8z",
    fill: props.color
  }));
}

export default SvgIconNotificationRexOutline;